import * as React from 'react';
import { OffboardingPage } from './OffboardingPage';

const EntraOffboarding: React.FunctionComponent = () => (
  <OffboardingPage taskDefId="entra-m365-app" heading="Entra" />
);

export { EntraOffboarding };
